export default "__VITE_ASSET__DTjwf$KX__"